import React, { Component } from 'react';
import { connect } from 'react-redux';
import ApplyCSS from '../ApplyCSS';
import commonUtil from '../../utils/commonUtil';
import { constDownload, constPrint } from '../../utils/clientConstant';

const brand = commonUtil.getBrand();

class DownloadPdf extends Component {
  constructor(props) {
    super(props);
    this.renderHTML = this.renderHTML.bind(this);
    this.fileName = '';
    this.getBrandLogoPath = this.getBrandLogoPath.bind(this);
    this.brandLogo = '';

    this.pageHeight = 1336;
    this.currentHeight = 0;
    this.totalPageHeight = 1336;
    this.pageMargin = 10;
  }

  offset = (el) => {
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let top = 0;
    let left = 0;
    let height = 0;
    let width = 0;
    let marginTop = 0;
    let marginBottom = 0;
    let paddingTop = 0;
    let paddingBottom = 0;
    let rect = null;
    let range = null;
    let computedStyle = null;
    let rects = [];

    if (el && el.nodeType) {
      if (el.nodeType === 3) {
        range = document.createRange();
        range.selectNodeContents(el);
        rects = range.getClientRects();
        if (rects.length > 0) {
          top = Math.ceil(rects[0].top + scrollTop);
          left = Math.ceil(rects[0].left + scrollLeft);
          height = Math.ceil(rects[rects.length - 1].top + rects[rects.length - 1].height);
          width = Math.ceil(rects[0].width);
        }
      } else if (el.nodeType === 1) {
        computedStyle = window.getComputedStyle(el);
        rect = (el.getBoundingClientRect) ? el.getBoundingClientRect() : null;

        top = Math.ceil(rect.top + scrollTop);
        left = Math.ceil(rect.left + scrollLeft);
        height = Math.ceil(rect.height);
        width = Math.ceil(rect.width);
        if (computedStyle) {
          paddingTop = computedStyle.getPropertyValue('padding-top').replace(/px|pt|em|%|mm|in|cm/gi, '');
          paddingBottom = computedStyle.getPropertyValue('padding-bottom').replace(/px|pt|em|%|mm|in|cm/gi, '');
          marginTop = computedStyle.getPropertyValue('margin-top').replace(/px|pt|em|%|mm|in|cm/gi, '');
          marginBottom = computedStyle.getPropertyValue('margin-bottom').replace(/px|pt|em|%|mm|in|cm/gi, '');

          paddingTop = isNaN(parseInt(paddingTop, 10)) ? Math.ceil(parseInt(paddingTop, 10)) : 0;
          paddingBottom = isNaN(parseInt(paddingBottom, 10)) ? Math.ceil(parseInt(paddingBottom, 10)) : 0;
          marginTop = isNaN(parseInt(marginTop, 10)) ? Math.ceil(parseInt(marginTop, 10)) : 0;
          marginBottom = isNaN(parseInt(marginBottom, 10)) ? Math.ceil(parseInt(marginBottom, 10)) : 0;

          // if ((computedStyle.marginTop && computedStyle.marginTop !== 'auto')) {
          //   marginTop = isNaN(parseInt(computedStyle.marginTop, 10)) ? Math.ceil(parseInt(computedStyle.marginTop, 10)) : 0;
          // }
          // if ((computedStyle.marginTop && computedStyle.marginTop !== 'auto')) {
          //   marginBottom = isNaN(parseInt(computedStyle.marginBottom, 10)) ? Math.ceil(parseInt(computedStyle.marginBottom, 10)) : 0;
          // }
        }
      }
    }
    if (rect) {
      return { top, left, height, width, marginTop, marginBottom, paddingTop, paddingBottom };
    }
    return null;
  }

  getBorderForTableRow = (tableRow) => {
    const computedStyle = window.getComputedStyle(tableRow);
    let borderSum = 0;
    if (computedStyle.borderBottomWidth !== '0px' || computedStyle.borderBottomWidth !== '0' || computedStyle.borderBottomWidth !== 'auto') {
      borderSum += parseInt(computedStyle.borderBottomWidth.replace('px', ''), 10);
    }
    if (computedStyle.borderTopWidth !== '0px' || computedStyle.borderTopWidth !== '0' || computedStyle.borderTopWidth !== 'auto') {
      borderSum += parseInt(computedStyle.borderTopWidth.replace('px', ''), 10);
    }
    return Math.ceil(borderSum);
  }

  handleTableObjectRendering = (tbl) => {
    const table = tbl;
    // let currentHeight = this.offset(document.querySelector('#divPrint .cTable tbody')).top;
    const tableDataRows = table.querySelectorAll('tr');
    if (tableDataRows && tableDataRows.length) {
      let tdCount = 0;
      if (tableDataRows.length > 1) { // get the length of columns
        tdCount = table.querySelector('tbody tr').querySelectorAll('td').length;
      }
      let spacerInserted = 0;
      if (tableDataRows.length === 1) { // scecnario for only header or one row
        const tableOffset = this.offset(table);
        if (tableOffset && ((tableOffset.top + tableOffset.height) > this.totalPageHeight)) {
          this.addSpacer(table, (this.totalPageHeight - this.currentHeight) + 'px', this.offset(table).top, true);
        }
      } else {
        tableDataRows.forEach((dataRow, index) => {
          let dataRowHeight = 0;
          const dataRowOffset = this.offset(dataRow);
          dataRowHeight = (dataRowOffset.top + dataRowOffset.height + dataRowOffset.paddingBottom + dataRowOffset.paddingTop);
          if (dataRowHeight > this.totalPageHeight) {
            // Insert blank row
            const rowHeight = (this.totalPageHeight - this.currentHeight);
            const row = table.insertRow((spacerInserted + index));
            spacerInserted += 1;
            row.setAttribute('border', 'none');
            row.setAttribute('class', 'dummyRow');
            row.setAttribute('style', 'height:' + rowHeight + 'px !important;');
            const cell1 = row.insertCell(0);
            cell1.innerText = ' ';
            cell1.setAttribute('align', 'center');
            cell1.setAttribute('colspan', tdCount);
            cell1.setAttribute('style', 'padding: 0;');
            this.setCurrentHeight(this.totalPageHeight + dataRowOffset.height);
            this.totalPageHeight = (this.pageHeight + this.totalPageHeight); //  + this.offset(dataRow).height
          } else {
            this.setCurrentHeight(dataRowHeight); // + this.getBorderForTableRow(dataRow);
          }
        });
      }
    }
  }

  handleLargeTextBlock = (el, pendingHeight) => {
    let heightToCheck = pendingHeight || this.pageHeight;

    // wrap text in element so we can get the client bounding rect for text
    let wrapperSection = document.createElement('section');
    wrapperSection.setAttribute('class', 'dummySection');
    el.parentNode.insertBefore(wrapperSection, el);

    // Check the height and create multiple divs based on height available / total height
    const words = el.nodeValue.split(' ');
    let randomWordCount = 0;
    let wrapperOldHeight = 0;
    while (randomWordCount <= words.length) {
      wrapperSection.append(words[randomWordCount] + ' ');
      const wrapperOffset = this.offset(wrapperSection);
      const wrapperBottom = wrapperOffset.height;
      if (wrapperBottom < heightToCheck) { // word fits in current line and is under specified asset
        this.setCurrentHeight(wrapperBottom);
        if (wrapperOldHeight !== wrapperBottom) { // word going beyond available asset
          wrapperOldHeight = wrapperBottom;
        }
      } else {
        // remove last inserted word from warpper and save it for return
        const temp = wrapperSection.innerText.split(' ');
        temp.pop();
        wrapperSection.innerText = temp.join(' ');
        // returnElements.push(wrapperSection);
        // Add spacer of 10px to push next section to new line
        this.addSpacer(wrapperSection, '10px', this.totalHeight + 'px');
        wrapperSection = null;
        // create new element
        wrapperSection = document.createElement('section');
        wrapperSection.append(words[randomWordCount] + ' ');
        el.parentNode.insertBefore(wrapperSection, el);
        // set global variables
        this.setCurrentHeight(this.totalPageHeight);
        this.totalPageHeight = this.totalPageHeight + this.pageHeight; // add new page
        heightToCheck = this.pageHeight;
      }
      // check the height of wrapperSection
      randomWordCount += 1;
      // check the size of wrappered div, add further text if wrapper height < (pageHeight - 50px)
    }
    el.remove();
  }

  addWrapper = (elem, tag = 'section') => {
    const wrapperSection = document.createElement(tag);
    wrapperSection.setAttribute('class', 'dummySection');
    elem.parentNode.insertBefore(wrapperSection, elem);
    wrapperSection.append(elem);
    return wrapperSection;
  }

  addSpacer = (elem, height, top, prepend = false, tag = 'section') => {
    const spacer = document.createElement(tag);
    spacer.setAttribute('class', 'spacer');
    spacer.setAttribute('width', '100%');
    spacer.setAttribute('top', top);
    // spacer.setAttribute('style', 'height: ' + height );
    spacer.setAttribute('style', 'height: ' + height + ';');
    spacer.innerHtml = '<i class="empty" />';
    if (prepend) {
      elem.prepend(spacer);
    } else {
      spacer.setAttribute('data-identifier', 'append');
      // elem.nextSibling.insertBefore(spacer, elem.nextSibling);
      elem.insertAdjacentElement('afterend', spacer);
    }
  }
  moveToNewPage = (el) => {
    // insert devider to move conyent to new Page
    const spaceHeight = (this.totalPageHeight - (this.currentHeight));
    this.addSpacer(el, spaceHeight + 'px', this.totalPageHeight, true);
    this.setCurrentHeight(this.totalPageHeight);
    this.totalPageHeight = this.pageHeight + this.totalPageHeight;
    // this.addSpacer(el, this.pageMargin, (this.currentHeight + 10 + 'px'), true);
  }

  setCurrentHeight = (height) => {
    if (height && height > this.currentHeight) {
      this.currentHeight = height;
    }
  }

  isActualTextNode = (elemValue) => {
    // const letters = new RegExp(/^[0-9a-zA-Z ]+$/);
    const valLength = elemValue.replace(/ /g, '').length;
    return valLength > 0;
  }

  getPreviousElementMarginForText = textElem =>
     this.offset(textElem.previousSibling)

  getChildNodes = el =>
     el.childNodes

  getElementBottom = (e1) => {
    const elementOffset = this.offset(e1);
    let bottom = 0;
    // let marginBottom = (elementOffset.marginBottom && elementOffset.marginBottom !== 'auto') ? elementOffset.marginBottom : 0;
    if (elementOffset) {
      bottom = elementOffset.top + elementOffset.height + elementOffset.marginBottom; // + elementOffset.paddingBottom + elementOffset.paddingTop; // + elementOffset.marginBottom;
    }
    return Math.ceil(bottom);
  }

  splitHTMLForPrintToPDF = (el) => {
    // decide if node is textNode or HTML
    const hasChild = el.hasChildNodes() && el.childElementCount;
    if (hasChild) { // we are still dealing with HTML
      const childNodes = this.getChildNodes(el);
      const childCount = el.childElementCount;
      childNodes.forEach((child, index) => { // iterate through each child
        if (child.classList && child.classList.contains('dummyPageBreak')) {
          this.moveToNewPage(child);
        }
        // TODO: need to check the pre-offset scenario and remove if not required
        const preOffset = (childCount > 1 && index > 0) ? this.getPreviousElementMarginForText(childNodes[index - 1]) : null;
        const childBottom = this.getElementBottom(child);
        const childNodeType = child.nodeType;
        let preMargin = 0;
        let textElem = null;
        // const isChildElement = false; // flag to decide if current element has text
        // If node type is text first wrap it within section
        if (childNodeType === 3) {
          textElem = this.addWrapper(child);
          if (preOffset && preOffset.marginBottom && preOffset.marginBottom !== 'auto') {
            preMargin = Math.ceil(preOffset.marginBottom) + Math.ceil(preOffset.marginTop);
          }
        }

        // Logic for split begins
        if (childBottom <= this.totalPageHeight) {
          this.setCurrentHeight(childBottom);
        } else {
          // const childOffset = this.offset(child);
          let remainingHeight = 0;
          // this.setCurrentHeight(childOffset.top);
          if (childNodeType === 3 && this.isActualTextNode(child.nodeValue)) {
            // const textElem = this.addWrapper(child);
            // childOffset = this.offset(textElem);
            const textElemBottom = this.getElementBottom(textElem) + preMargin;
            if (textElemBottom <= this.totalPageHeight) {
              this.setCurrentHeight(textElemBottom);
            } else {
              remainingHeight = (this.totalPageHeight - this.currentHeight);
              this.handleLargeTextBlock(child, remainingHeight);
              // TODO: check need of appending devider
            }
          } else if (childNodeType === 1) { // proper scementic HTML elements like DIV, P, TABLE, HEADER, FOOTER, SECTION..... etc.....
            if (child.nodeName.toLowerCase() === 'table') {
              this.handleTableObjectRendering(child);
            } else if (child.hasChildNodes() && child.childElementCount) { // container elements usually has height as 0 but do contain lot of content
              // if (childOffset.height <= this.pageHeight) { // check if element cab be fit in one single page
              //   this.addSpacer(child, ((this.totalPageHeight - this.currentHeight) + 'px'), (childBottom + 'px'), true);
              //   this.setCurrentHeight(this.totalPageHeight);
              //   this.totalPageHeight = this.pageHeight + this.totalPageHeight;
              // } else {
              //   // this.setCurrentHeight(childOffset.top);
              this.splitHTMLForPrintToPDF(child);
              // }
            } else {
              // insert devider
              this.addSpacer(child, ((this.totalPageHeight - this.currentHeight) + 'px'), (childBottom + 'px'), true);
              this.setCurrentHeight(this.totalPageHeight);
              this.totalPageHeight = this.pageHeight + this.totalPageHeight;
              this.addSpacer(child, '10px', (this.totalHeight + 10 + 'px'));
            }
          }
        }
        // }
      });
    } else { // logic to split large chunk of text, assuming if html is not having any child nodes it is text
      // this.setCurrentHeight(this.currentHeight);
      this.handleLargeTextBlock(el, (this.totalPageHeight - this.currentHeight));
    }
  }

  componentDidMount() {
    const openerContainer = this.renderHTML();
    if (openerContainer) {
      document.querySelector('#divPrint').classList.value = openerContainer.classList.value;
      document.querySelector('#divPrint').innerHTML = openerContainer.innerHTML;
      document.querySelectorAll('#divPrint .exclude-for-print-download').forEach((element) => {
        element.classList.add('display-none');
      });

      if (this.props && this.props.params && this.props.params.content === constPrint) {
        this.fileName = this.props.params.fileName;
        if (typeof window !== 'undefined' && window.location.pathname.indexOf('tableOrganizer') > -1) {
          const css = '@page { size: letter landscape; }';
          const head = document.head || document.getElementsByTagName('head')[0];
          const style = document.createElement('style');

          style.type = 'text/css';
          style.media = 'print';

          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            style.appendChild(document.createTextNode(css));
          }
          head.appendChild(style);
        }
        setTimeout(() => { window.print(); }, 500);
      } else if (this.props && this.props.params && this.props.params.content === constDownload) {
        this.fileName = this.props.params.fileName;
        // logic to split contract data - START
        this.splitHTMLForPrintToPDF(document.querySelector('#divPrint'));
        // Logic for splitting data - end
        if (typeof window !== 'undefined' && window.location.pathname.indexOf('tableOrganizer') > -1) {
          setTimeout(() => { commonUtil.downloadPdf('.printPage', `${this.fileName}.pdf`, 'l'); }, 500);
        } else {
          setTimeout(() => { commonUtil.downloadPdf('.printPage', `${this.fileName}.pdf`); }, 500);
        }
      }
    }
  }
  getBrandLogoPath = (opt) => {
    let path = '';
    switch (opt) {
      case 'LP':
        path = commonUtil.getAssetURL() + '/images/liverpool_logo.gif';
        break;
      case 'PB':
        path = commonUtil.getAssetURL() + '/images/logos/logo-pb.png';
        break;
      case 'PBK':
        path = commonUtil.getAssetURL() + '/images/logos/logo-pbk.png';
        break;
      case 'GAP':
        path = commonUtil.getAssetURL() + '/images/logoGap.png';
        break;
      case 'WLM':
        path = commonUtil.getAssetURL() + '/images/logos/logo_we.png';
        break;
      case 'WS':
        path = commonUtil.getAssetURL() + '/images/logos/logo-ws.png';
        break;
      case 'TRU':
        path = commonUtil.getAssetURL() + '/images/logo-toys.png';
        break;
      default:
        break;
    }
    return path;
  }
  renderHTML = () => {
    if (typeof document !== 'undefined' && window.opener !== null) {
      const elementSelector = window.opener.document.querySelector('.toPrint');
      return elementSelector;
    }
    return null;
  }
  render() {
    this.brandLogo = this.getBrandLogoPath(brand);
    let settingCSS = {};
    if (typeof window !== 'undefined' && window.location.pathname.indexOf('tableOrganizer') > -1) {
      settingCSS = { width: 'auto' };
      if (typeof document !== 'undefined' && document.querySelector('.dropArea')) {
        settingCSS.width = document.querySelector('.dropArea').style.width;
      }
    }
    const mesa_de_regalos_logo = commonUtil.getImageMeta().mesaDeRegalosLogo;

    return (
      <div className="printPage" style={settingCSS}>
        <ApplyCSS pageName={this.props.params.pageName} />
        <div className="row pdfclass">
          <div className="col-xs-6 col-sm-6 pdf-header-imgs">
            <img src={this.brandLogo} className='brand-img-logo' />
            <img className="pdf-mesalogo" src={mesa_de_regalos_logo} />
          </div>
            <div className="col-xs-6 col-sm-6 text-right mt-15">
              <div className="mt-15">{commonUtil.formatDate(this.props.printingDate, 'dd/mm/yyyy')}</div>
            </div>
        </div>
        <div id="divPrint" />
        <div className="downloadprint-overlay" />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  printingDate: state.info && state.info.data && state.info.data.time,
});

export default connect(mapStateToProps, undefined)(DownloadPdf);
